import { Box } from '@mui/material';
import { CatalogProductsTestIds } from '../../../../../../utils/testIds/CatalogProducts.testIds';

interface CatalogDropIndicatorProps {
  orientation: 'vertical' | 'horizontal';
}

export const INDICATOR_THICKNESS = 3;

const CatalogDropIndicator = ({ orientation }: CatalogDropIndicatorProps) => {
  const isVertical = orientation === 'vertical';

  return (
    <Box
      test-id={CatalogProductsTestIds.DROP_INDICATOR}
      sx={{
        position: 'absolute',
        zIndex: 1,
        borderRadius: 1,
        backgroundColor: 'primary.main',
        pointerEvents: 'none',
        ...(isVertical
          ? { top: 0, bottom: 0, width: INDICATOR_THICKNESS }
          : { left: 0, right: 0, height: INDICATOR_THICKNESS }),
      }}
    />
  );
};

export default CatalogDropIndicator;
